import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
// import {MAIN_TXT_COLOR} from "../contants/themes"
import {
	MdHome as HomeIcon,
	MdInsertDriveFile as ContractIcon,
	MdAddCircle as PlusIcon,
	MdNotifications as NotificationIcon,
	MdAccountCircle as UserIcon

} from "react-icons/md";
import { BsFillBarChartFill as ClaimIcon } from "react-icons/bs"
import { useAppContext } from 'contexts/AppContext';
const MAIN_TXT_COLOR = "var(--color-primary)"
const useStyles = makeStyles({
	active: {
		color: "var(--color-primary)",
		fontWeight: "bold"
	}
});
const contractFlow = ['contract', 'contract-detail', 'create-claim']
const SaleNavigation = props => {
	const { getUserInfo } = useAppContext();
	const location = useLocation();
	const classes = useStyles();
	const history = useHistory()
	const [activeTabs, setActiveTabs] = useState(props.name ? props.name : location.pathname.split("/")[2])
	const [permissions, setPermissions] = useState([]);
	useEffect(() => {
		switch (activeTabs) {
			case '':
				history.push('/sale')
				break;
			case 'order':
				history.push('/sale/order')
				break;
			case 'account':
				history.push('/sale/account')
				break;
			default:
				break;
		}
	}, [activeTabs, history])

	useEffect(() => {

		const user = getUserInfo();
		if (user) {
			setPermissions(user.permissions);
		}
	}, []);

	return (
		<div className='bottom-nav'>
			<div className='bn-tab-sale item_link'
				onClick={() => setActiveTabs('')}
			>
				<a className={"btn btn-navLink"}>
					<div className={"nav-icon"}>
						{activeTabs === '' || typeof activeTabs === 'undefined'?
							<HomeIcon
								size='20'
								color={MAIN_TXT_COLOR}
							/> :
							<HomeIcon
								size='20'
								color={"var(--nav-txt-color)"}
							/>
						}
					</div>
					<div className={"nav-txt " + classNames({ [classes.active]: activeTabs === ''})}>Trang chủ</div>
				</a>


			</div>
			{
				(permissions.includes('SALE_PRODUCT_AUTOCARE') || permissions.includes('SALE_PRODUCT_AUTOCARE_NOPAY')) &&
				<div className='bn-tab-sale'
					onClick={() => setActiveTabs('order')}
				>
					<a className={"btn btn-navLink"}>
						<div className={"nav-icon"}>
							{activeTabs === 'order' ?
								<ContractIcon
									size='20'
									color={MAIN_TXT_COLOR}
								/> :
								<ContractIcon
									size='20'
									color={"var(--nav-txt-color)"}
								/>}
						</div>
						<div className={"nav-txt " + classNames({ [classes.active]: activeTabs === 'order' })}>Đơn hàng</div>
					</a>

				</div>
			}
			
			
			<div className='bn-tab-sale'
				onClick={() => setActiveTabs('account')}
			>
				<a className={"btn btn-navLink"}>
					<div className={"nav-icon"}>{activeTabs === 'account' ?
						<UserIcon
							size='20'
							color={MAIN_TXT_COLOR}
						/> :
						<UserIcon
							size='20'
							color={"var(--nav-txt-color)"}
						/>
					}
					</div>
					<div className={"nav-txt " + classNames({ [classes.active]: activeTabs === 'account' })}>Tài khoản</div>
				</a>

			</div>
		</div>
	)
}

export default SaleNavigation
